import React from 'react'

export default props => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500"><title>Artboard 2asdff</title><path d="M250-.5C111.93-.5,0,111.43,0,249.5s111.93,250,250,250,250-111.93,250-250S388.07-.5,250-.5ZM298.46,391H195.38V220.5a77.7,77.7,0,0,0,103.08-2.72ZM245.38,214.12A53.08,53.08,0,1,1,298.46,161,53.08,53.08,0,0,1,245.38,214.12Z"/></svg>
    )



// WEBPACK FOOTER //
// ./src/App/Menu/MenuHome/about-icon-svg.js